import React, { useContext } from 'react'
import packageJson from '../../package.json'
import { useSelector, useDispatch } from 'react-redux'
import PropTypes from 'prop-types';
// import { ShowLogoProvider } from '../ShowLogoContext'; // Importa el contexto
import '../scss/style.scss'
import {
  CAvatar,
  CCloseButton,
  CImage,
  CSidebar,
  CSidebarBrand,
  CSidebarFooter,
  CSidebarHeader,
  CSidebarToggler,
  CDropdown,
  CDropdownMenu,
  CDropdownItem,
  CDropdownDivider,
  CButton,
  CDropdownToggle,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'

import {
  cilBell,
  cilCalculator,
  cilChartPie,
  cilCursor,
  cilDescription,
  cilDrop,
  cilNotes,
  cilPencil,
  cilPuzzle,
  cilSpeedometer,
  cilStar,
} from '@coreui/icons'

import { AppSidebarNav } from './AppSidebarNav'

// import { logo } from '../assets/brand/logo'
import logoCognitive from '../assets/images/logo-cognitive.png'
import logoCog from '../assets/images/logo-cog.png'
// import  Avatar1  from '../assets/images/avatars/1.jpg'
// logoacya.PNG
import { sygnet } from '../assets/brand/sygnet'

// sidebar nav config
import navigation from '../_nav'
import { useState } from 'react'

function logout() {

  localStorage.removeItem('token');
  localStorage.removeItem('name');
  localStorage.removeItem('email');
  localStorage.removeItem('total');
  localStorage.removeItem('avatar');
  localStorage.removeItem('banner');
  localStorage.removeItem('id');
  window.location = '/';

}

const AppSidebar = ({ setProfile }) => {
  const dispatch = useDispatch()
  const narrow = useSelector((state) => state.sidebarnarrow)
  const sidebarShow = useSelector((state) => state.sidebarShow)
  const [username, setUsername] = useState(localStorage.getItem('name'));
  const [email, setEmail] = useState(localStorage.getItem('email'));
  const [showLogo, setShowLogo] = useState(!narrow);

  // Dynamic user logo/avatar
  const userBanner = localStorage.getItem('banner') || '/UTNTRANSP.webp';
  const userAvatar = localStorage.getItem('avatar') || '/UTNTRANSP.webp';
  const logo = userBanner;
  const logoAcya = userBanner;
  const Avatar1 = userAvatar;

  // Función para obtener datos del servidor
  function truncateText(text, maxLength, truncationText = "...") {
    if (text.length > maxLength) {
      return text.substring(0, maxLength) + truncationText;
    }
    return text;
  }


  return (
    <CSidebar
      className="border-end sidebar-bg-orange"
      colorScheme="dark"
      position="fixed"
      narrow={narrow}
      visible={sidebarShow}
    >
      <CSidebarFooter className="border-top d-none d-lg-flex sidebar-icono-recoger">
        <CSidebarToggler className='sidebar-toggler-icon'
          onClick={() => {
            dispatch({ type: 'set', sidebarnarrow: !narrow, });
            setShowLogo(!showLogo);
            localStorage.setItem('showLogo', !showLogo);
            setProfile(!showLogo ? 'false' : 'true');
          }}

        />
      </CSidebarFooter>
      <CSidebarHeader className="d-flex justify-content-center align-items-center">
        <CSidebarBrand to="/" className="w-100 d-flex justify-content-center align-items-center">
          <div className="d-flex justify-content-center align-items-center w-100">
            {showLogo ? (
              <img className="" src={logo} alt="Mi logo" height={55} style={{ objectFit: 'contain', maxWidth: '90%' }} />
            ) : (
              <img className="" src={logoAcya} alt="Mi logo" height={45} style={{ objectFit: 'contain', maxWidth: '90%' }} />
            )}
          </div>
          {/* <CIcon customClassName="sidebar-brand-narrow" icon={sygnet} height={32} /> */}
        </CSidebarBrand>
        <CCloseButton
          className="d-lg-none"
          dark
          onClick={() => dispatch({ type: 'set', sidebarShow: false })}
        />
      </CSidebarHeader>
      <AppSidebarNav items={navigation} />
      {/* <CSidebarFooter className="border-top d-none d-lg-flex">
        Logout
        <CSidebarToggler
          // onClick={logout}
          onClick={() => dispatch({ type: 'set', sidebarUnfoldable: !unfoldable })}
        />
      </CSidebarFooter> */}

      <CSidebarFooter className="d-none d-lg-flex">

        <CDropdown variant="btn-group" direction="dropup">
          {/* <CButton color="secondary" >Small split button</CButton> */}
          <div className="sidebar-footer-content-all">
            {showLogo ? (
              <>
                <div className="sidebar-footer-content">
                  <div className="">
                    <CAvatar src={Avatar1} />
                  </div>
                  <div className="">
                    <div className="sidebar-footer-name" title={truncateText(username, 10) === username ? '' : username}>
                      {/* <strong>Nombre Apellido</strong> */}
                      <strong>{truncateText(username, 18)}</strong>
                    </div>
                    <div className="sidebar-footer-email" title={truncateText(email, 10) === email ? '' : email}>
                      {/* correo@ejemplo.com */}
                      {truncateText(email, 20)}
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <div className="sidebar-footer-left">
                <CAvatar src={Avatar1} />
              </div>
            )}


          </div>

          {showLogo ? (
            <>
              <CDropdownToggle style={{ '--cui-btn-border-width': '0px' }} />
              <CDropdownMenu>
                <CDropdownItem href="#"><div className="sidebar-footer-content-all">
                  <div className="sidebar-footer-content">
                    <div className="">
                      <CAvatar src={Avatar1} />
                    </div>
                    <div className="">
                      <div className="sidebar-footer-name">
                        {/* <strong>Nombre Apellido</strong> */}
                        <strong>{username}</strong>
                      </div>
                      <div className="sidebar-footer-email">
                        {/* correo@ejemplo.com */}
                        {email}
                      </div>
                    </div>
                  </div>
                </div></CDropdownItem>
                <CDropdownDivider />
                <CDropdownItem href="/profile/user">Ver perfil usuario</CDropdownItem>
                <CDropdownItem className="cursor-pointer" onClick={logout}>Cerrar sesión</CDropdownItem>

              </CDropdownMenu>

            </>
          ) : (
            <div className="sidebar-footer-left">

            </div>
          )}


        </CDropdown>
      </CSidebarFooter>
      <CSidebarFooter className="border-top d-none d-lg-flex flex-column align-items-center py-2" style={{ gap: '8px' }}>
        {showLogo && (
          <div style={{ fontSize: '11px', color: 'rgba(255,255,255,0.4)', fontWeight: 'bold', letterSpacing: '1px' }}>
            VERSION V{packageJson.version}
          </div>
        )}
        {showLogo ? (
          <img className="sidebar-brand-narrow" src={logo} alt="Mi logo" height={45} style={{ objectFit: 'contain', maxWidth: '90%' }} />
        ) : (
          <img className="sidebar-brand-full" src={logoAcya} alt="Mi logo" height={30} style={{ objectFit: 'contain', maxWidth: '90%' }} />
        )}
      </CSidebarFooter>
    </CSidebar >
  )
}

AppSidebar.propTypes = {
  setProfile: PropTypes.func.isRequired

}

export default React.memo(AppSidebar)
